/* Oji Matcha — review submission modal wizard (Reviews UI v2 / W2). Vanilla, no deps. Loaded with defer. */
(function () {
  "use strict";

  var MAX_FILES = 5;
  var MAX_IMAGE_BYTES = 5 * 1024 * 1024;
  var ALLOWED = ["image/jpeg", "image/png", "image/webp"];
  var VIDEO_ALLOWED = ["video/mp4", "video/quicktime", "video/webm"];
  var MAX_VIDEO_BYTES = 30 * 1024 * 1024;
  var TOTAL_STEPS = 3;
  var SUCCESS_CLOSE_DELAY = 2800;

  var ERRORS = {
    rating: "Selecciona una puntuación de 1 a 5.",
    name: "Escribe tu nombre (máx. 50 caracteres).",
    email: "Escribe un email válido.",
    title: "Escribe un título (máx. 80 caracteres).",
    body: "Escribe tu reseña (máx. 1000 caracteres).",
    location: "La ubicación es demasiado larga.",
    links_not_allowed: "No se permiten enlaces en la reseña.",
    product: "No se pudo identificar el producto.",
    turnstile: "Completa la verificación anti-spam e inténtalo de nuevo.",
    rate_limited: "Demasiados envíos. Inténtalo más tarde.",
    duplicate: "Esta reseña ya fue enviada.",
    create_failed: "No pudimos guardar tu reseña. Inténtalo de nuevo.",
    bad_signature: "Sesión no válida. Recarga la página.",
    bad_request: "Formulario incompleto.",
    network: "Error de conexión. Inténtalo de nuevo."
  };

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return "n-" + Date.now() + "-" + Math.floor(Math.random() * 1e9);
  }

  function getFocusable(container) {
    if (!container) return [];
    var nodes = container.querySelectorAll('button, a[href], input, textarea, select, [tabindex]:not([tabindex="-1"])');
    // offsetParent === null already excludes anything inside a display:none
    // ancestor (e.g. a hidden [data-wizard-step] fieldset). It does NOT
    // exclude off-screen-but-rendered elements such as the honeypot input
    // (positioned off-canvas via .oji-review-form__hp, non-null offsetParent),
    // so explicitly drop anything with tabindex="-1" — the honeypot carries
    // tabindex="-1" precisely so it's never a legitimate tab stop.
    return Array.prototype.filter.call(nodes, function (el) {
      return !el.disabled && el.offsetParent !== null && el.tabIndex !== -1;
    });
  }

  function init(form) {
    var wrap = form.closest("[data-oji-review-form-wrap]");
    if (!wrap) return;

    var dialog = wrap.querySelector(".oji-review-modal__dialog");
    var backdrop = wrap.querySelector("[data-oji-review-backdrop]");
    var closeBtn = wrap.querySelector("[data-oji-review-close]");
    var wizard = wrap.querySelector("[data-oji-review-wizard]");
    var successEl = wrap.querySelector("[data-oji-review-success]");
    var successMessageEl = wrap.querySelector("[data-oji-review-success-message]");

    var endpoint = form.getAttribute("data-endpoint");
    var statusEl = form.querySelector("[data-oji-review-status]");
    var primaryBtn = form.querySelector("[data-oji-review-primary]");
    var backBtn = form.querySelector("[data-oji-review-back]");
    var photoInput = form.querySelector("[data-oji-review-photos]");
    var thumbs = form.querySelector("[data-oji-review-thumbs]");
    var dropzone = form.querySelector("[data-oji-review-dropzone]");
    var titleInput = form.querySelector("#oji-rf-title");
    var bodyInput = form.querySelector("#oji-rf-body");

    var panels = Array.prototype.slice.call(form.querySelectorAll("[data-wizard-step]"));
    var stepButtons = Array.prototype.slice.call(wrap.querySelectorAll("[data-step-btn]"));
    var stepLines = Array.prototype.slice.call(wrap.querySelectorAll("[data-step-line]"));

    var currentStep = 1;
    var lastFocused = null;
    var successTimer = null;

    /* ---------------------------------------------------------------
       Modal shell — proven v4 drawer pattern (assets/oji-v4.js:206-263),
       reimplemented standalone (no import, no Lenis).
       --------------------------------------------------------------- */
    function trapKeydown(e) {
      if (e.key === "Escape") { closeModal(); return; }
      if (e.key !== "Tab") return;
      var focusable = getFocusable(dialog);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function openModal() {
      lastFocused = document.activeElement;
      wrap.hidden = false;
      wrap.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      wizard.hidden = false;
      successEl.hidden = true;
      clearTimeout(successTimer);
      goToStep(1, { silent: true });
      requestAnimationFrame(function () { wrap.classList.add("is-open"); });
      if (closeBtn) closeBtn.focus();
      document.addEventListener("keydown", trapKeydown);
    }

    function closeModal() {
      wrap.classList.remove("is-open");
      wrap.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      document.removeEventListener("keydown", trapKeydown);
      wrap.hidden = true;
      if (lastFocused && document.contains(lastFocused)) lastFocused.focus();
      lastFocused = null;
    }

    var openBtns = document.querySelectorAll("[data-oji-review-open]");
    Array.prototype.forEach.call(openBtns, function (btn) {
      btn.addEventListener("click", openModal);
    });
    if (closeBtn) closeBtn.addEventListener("click", closeModal);
    if (backdrop) backdrop.addEventListener("click", closeModal);

    /* Deep-link: /products/<handle>?resena=1 opens the form on load. The
       post-purchase review email links here — without it the email drops the
       customer on a long PDP and asks them to hunt for the button, which is
       where review conversion goes to die. The parameter is stripped after
       opening so a refresh (or the Reviews UI v2 re-init) does not reopen it.
       Spelled without the tilde on purpose: accented query params get
       percent-encoded in transit by mail clients and link trackers. */
    try {
      var qp = new URLSearchParams(window.location.search);
      if (qp.get("resena") === "1") {
        openModal();
        qp.delete("resena");
        var rest = qp.toString();
        history.replaceState(
          null,
          "",
          window.location.pathname + (rest ? "?" + rest : "") + window.location.hash
        );
      }
    } catch (e) {
      /* URLSearchParams/replaceState unavailable — the deep-link simply
         no-ops and the button still works. */
    }

    /* ---------------------------------------------------------------
       Wizard step navigation.
       --------------------------------------------------------------- */
    function goToStep(n, opts) {
      opts = opts || {};
      currentStep = n;

      panels.forEach(function (panel) {
        var s = Number(panel.getAttribute("data-wizard-step"));
        panel.hidden = s !== n;
      });

      stepButtons.forEach(function (btn) {
        var s = Number(btn.getAttribute("data-step-btn"));
        btn.classList.remove("is-current", "is-complete", "is-upcoming");
        if (s === n) {
          btn.classList.add("is-current");
          btn.setAttribute("aria-current", "step");
          btn.disabled = true;
        } else if (s < n) {
          btn.classList.add("is-complete");
          btn.removeAttribute("aria-current");
          btn.disabled = false;
        } else {
          btn.classList.add("is-upcoming");
          btn.removeAttribute("aria-current");
          btn.disabled = true;
        }
      });

      stepLines.forEach(function (line) {
        var after = Number(line.getAttribute("data-step-line"));
        line.classList.toggle("is-filled", after < n);
      });

      if (backBtn) backBtn.hidden = n === 1;
      if (primaryBtn) {
        if (n === TOTAL_STEPS) {
          primaryBtn.type = "submit";
          primaryBtn.textContent = "Enviar reseña";
        } else {
          primaryBtn.type = "button";
          primaryBtn.textContent = "Continuar";
        }
      }

      clearStatus();

      if (!opts.silent) {
        var activePanel = panels.filter(function (p) { return Number(p.getAttribute("data-wizard-step")) === n; })[0];
        if (activePanel) activePanel.focus();
      }
    }

    stepButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.disabled) return;
        var s = Number(btn.getAttribute("data-step-btn"));
        goToStep(s);
      });
    });

    if (backBtn) {
      backBtn.addEventListener("click", function () {
        goToStep(Math.max(1, currentStep - 1));
      });
    }

    if (primaryBtn) {
      primaryBtn.addEventListener("click", function (e) {
        if (currentStep === TOTAL_STEPS) return; // submit button — form's submit handler takes over
        e.preventDefault();

        if (currentStep === 1) {
          var ratingChecked = form.querySelector('input[name="rating"]:checked');
          if (!ratingChecked) { setStatus(ERRORS.rating, false); return; }
        } else if (currentStep === 2) {
          if (!titleInput.value.trim()) { setStatus(ERRORS.title, false); return; }
          if (!bodyInput.value.trim()) { setStatus(ERRORS.body, false); return; }
        }

        goToStep(currentStep + 1);
      });
    }

    /* ---------------------------------------------------------------
       Photo/video dropzone — pre-validation + thumbnails (carried over).
       --------------------------------------------------------------- */
    if (photoInput) {
      photoInput.addEventListener("change", function () {
        thumbs.innerHTML = "";
        var files = Array.prototype.slice.call(photoInput.files);
        if (files.length > MAX_FILES) {
          setStatus("Máximo " + MAX_FILES + " fotos. Se usarán las primeras " + MAX_FILES + ".", false);
        }
        files.slice(0, MAX_FILES).forEach(function (file) {
          var isImage = ALLOWED.indexOf(file.type) !== -1 && file.size <= MAX_IMAGE_BYTES;
          var isVideo = VIDEO_ALLOWED.indexOf(file.type) !== -1 && file.size <= MAX_VIDEO_BYTES;
          if (!isImage && !isVideo) {
            setStatus("Algún archivo no es válido (fotos JPG/PNG/WebP máx. 5 MB; videos MP4/MOV/WebM máx. 30 MB) y se omitirá.", false);
            return;
          }
          if (isVideo) {
            var video = document.createElement("video");
            video.className = "oji-review-form__thumb oji-review-form__thumb--video";
            video.muted = true;
            video.preload = "metadata";
            video.playsInline = true;
            video.src = URL.createObjectURL(file);
            thumbs.appendChild(video);
            return;
          }
          var img = document.createElement("img");
          img.className = "oji-review-form__thumb";
          img.alt = "";
          img.src = URL.createObjectURL(file);
          thumbs.appendChild(img);
        });
      });
    }

    if (dropzone && photoInput) {
      dropzone.addEventListener("click", function () {
        photoInput.click();
      });
      dropzone.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
          e.preventDefault();
          photoInput.click();
        }
      });
      ["dragover", "dragenter"].forEach(function (evt) {
        dropzone.addEventListener(evt, function (e) {
          e.preventDefault();
          dropzone.classList.add("is-dragover");
        });
      });
      ["dragleave", "drop"].forEach(function (evt) {
        dropzone.addEventListener(evt, function (e) {
          e.preventDefault();
          dropzone.classList.remove("is-dragover");
        });
      });
      dropzone.addEventListener("drop", function (e) {
        e.preventDefault();
        if (!window.DataTransfer) {
          setStatus("Arrastrar no es compatible con este navegador. Haz clic para elegir los archivos.", false);
          return;
        }
        try {
          var incoming = (e.dataTransfer && e.dataTransfer.files) || [];
          var dt = new DataTransfer();
          Array.prototype.forEach.call(incoming, function (file) {
            dt.items.add(file);
          });
          photoInput.files = dt.files;
          photoInput.dispatchEvent(new Event("change", { bubbles: true }));
        } catch (err) {
          setStatus("No se pudo procesar el arrastre. Haz clic para elegir los archivos.", false);
        }
      });
    }

    function setStatus(msg, ok) {
      statusEl.hidden = false;
      statusEl.textContent = msg;
      statusEl.classList.toggle("is-error", ok === false);
      statusEl.classList.toggle("is-success", ok === true);
    }

    function clearStatus() {
      statusEl.hidden = true;
      statusEl.textContent = "";
      statusEl.classList.remove("is-error", "is-success");
    }

    function resetTurnstile() {
      if (window.turnstile && typeof window.turnstile.reset === "function") {
        try { window.turnstile.reset(); } catch (e) {}
      }
    }

    /* ---------------------------------------------------------------
       Animated thank-you.
       --------------------------------------------------------------- */
    function showSuccess() {
      var successHtml = form.getAttribute("data-success") || "¡Gracias — tu reseña ya está publicada!";
      wizard.hidden = true;
      successEl.hidden = false;
      successMessageEl.innerHTML = successHtml;

      form.reset();
      thumbs.innerHTML = "";
      resetTurnstile();

      clearTimeout(successTimer);
      successTimer = setTimeout(function () {
        closeModal();
        if (typeof window.__ojiReviewsRefresh === "function") {
          window.__ojiReviewsRefresh();
        } else {
          location.reload();
        }
      }, SUCCESS_CLOSE_DELAY);
    }

    /* ---------------------------------------------------------------
       Submit — step 3 only (server stays source of truth).
       --------------------------------------------------------------- */
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (currentStep !== TOTAL_STEPS) return;

      var data = new FormData(form);
      data.set("nonce", uuid());

      // Client-side pre-check for a friendlier UX (server re-validates).
      if (!data.get("rating")) { goToStep(1); setStatus(ERRORS.rating, false); return; }
      if (!String(data.get("reviewer_name") || "").trim()) { setStatus(ERRORS.name, false); return; }
      if (!String(data.get("email") || "").trim()) { setStatus(ERRORS.email, false); return; }

      primaryBtn.disabled = true;
      primaryBtn.setAttribute("aria-busy", "true");
      setStatus("Enviando…", null);

      fetch(endpoint, { method: "POST", body: data })
        .then(function (res) { return res.json().then(function (j) { return { status: res.status, body: j }; }); })
        .then(function (r) {
          if (r.body && r.body.ok) {
            showSuccess();
          } else {
            var key = (r.body && r.body.error) || "network";
            setStatus(ERRORS[key] || ERRORS.network, false);
            resetTurnstile();
          }
        })
        .catch(function () { setStatus(ERRORS.network, false); resetTurnstile(); })
        .then(function () {
          primaryBtn.disabled = false;
          primaryBtn.removeAttribute("aria-busy");
        });
    });
  }

  function initAll() {
    var forms = document.querySelectorAll("[data-oji-review-form]");
    Array.prototype.forEach.call(forms, init);
  }

  // readyState-aware bootstrap (matches assets/oji-pdp-reviews.js): on the
  // initial page load this script runs `defer`, i.e. after parsing but
  // before DOMContentLoaded fires, so the "loading" branch below is taken.
  // After a W3 auto-refresh (Reviews UI v2) re-executes this script tag on
  // fresh DOM, DOMContentLoaded has already fired once for the document and
  // will never fire again — a listener added at that point would silently
  // never run, leaving the re-rendered "Escribir una reseña" button and
  // modal unbound. Checking readyState first covers both cases.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
